import Meta from '@/components/common/Meta'

import DormMovingStoragePage from '@/v2/components/pages/landing-pages/dorm-moving-storage-page'
import { LANDING_PAGES_META_CONTENTS } from '@/v2/constants/pages/landing-pages/meta/landing-pages-meta-content'
import { metaImages, ogImages } from '@/v2/constants/pages/landing-pages/dorm-moving-storage-page'

interface DormMovingStoragePageProps {}

const Page: React.FC<DormMovingStoragePageProps> = () => {
  return (
    <>
      <Meta
        title={
          LANDING_PAGES_META_CONTENTS.dorm_moving_storage.title ?? LANDING_PAGES_META_CONTENTS.default?.title ?? ''
        }
        keywords={
          LANDING_PAGES_META_CONTENTS.dorm_moving_storage?.keywords ??
          LANDING_PAGES_META_CONTENTS.default?.keywords ??
          ''
        }
        description={
          LANDING_PAGES_META_CONTENTS.dorm_moving_storage?.description ??
          LANDING_PAGES_META_CONTENTS.default?.description ??
          ''
        }
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
      />

      <DormMovingStoragePage />
    </>
  )
}

export default Page
